$(document).ready(function() {
	if(!document.querySelector('.ocr-gate')) return false;
	// LGEGMC-4632 start
	var fileSelect = document.getElementsByClassName("registerFileSelect"),
	fileElem = document.getElementsByClassName("registerFileElem");
	// LGEGMC-4632 end
	
	var device = "pc";
	var mobileArr = new Array("iphone", "ipod", "android", "windows ce", "blackberry", "symbian", "windows phone", "webos", "opera mini", "opera mobi", "polaris","iemobile", "lgtelecom", "nokia", "sonyericsson", "samsung");

	//디바이스 체크
	for(var txt in mobileArr){
		if(navigator.userAgent.toLowerCase().match(mobileArr[txt]) != null){
			console.log(navigator.userAgent.match(mobileArr[txt]));
			device = "mobile"
			break;
		}
	}

	// LGEGMC-3937 Start
	const scanQR = '.registerScanQRcode'; // LGEGMC-4632
	const scanQRcodeFlag = $('#scanQRcodeFlag').val() === 'Y' ? true : false;
	let postScannedQR = 'N';

	if(scanQRcodeFlag){
		const $btnFindMyQrCode = $('.modal-area.active a');
		$btnFindMyQrCode.text( $btnFindMyQrCode.data('qrMsg') ).attr('href','#modal_find_my_model_qrcode');
		
		// LGEGMC-4632 start
		const $btnFindMyQrCodeMobile = $('.ocr-buttons-container .top-area a');
		if( $btnFindMyQrCodeMobile.length > 0){
			$btnFindMyQrCodeMobile.text( $btnFindMyQrCodeMobile.data('qrMsg') ).attr('href','#modal_find_my_model_qrcode');
		}
		// LGEGMC-4632 end
	}
	// LGEGMC-3937 End

	const thinqReg = thinqRegisterProduct; // LGEGMC-4167 :: in common.js

	if(device == 'mobile'){
		var mobileBtnMsg = $('#mBtnMsg').val();
		$('.registerFileSelect').text(mobileBtnMsg); // LGEGMC-4632
	}

	var allowedFileExt = ['jpg', 'png', 'gif', 'tif', 'jfif'];

	// LGEGMC-3937 Start
	// 기존 var ocr Object 내 존재했던 모델 조회 ajax 공통화 분리
	var redirectUrl = $('.btn-area').find('.btn-outline-secondary').attr('href');
	function SubmitRegisterScan(productList, serialList){
		//LGEJP-396
		var obuCodeList = $('input[name="obuCodeList"]').val();
		if(obuCodeList != 'undefined' && obuCodeList != null && obuCodeList != '' )
			obuCodeList  =	obuCodeList.split(',');

		var csSalesCodeStr = '';
		var csThinqSalesCodeStr = '';	//LGEITF-1012
		//LGEJP-396
		var obuFlag = false;

		if(!isEmpty(productList)){
			for(var i = 0; i < productList.length; i++){
				if(obuCodeList != 'undefined' && obuCodeList != null && obuCodeList != '' ){
					for(var j = 0; j < obuCodeList.length; j++ ){
						if(obuCodeList[j] == productList[i].obuCode){
							obuFlag = true;
							break;
						 }
				   }
				}
				if(i == productList.length-1){
					obuFlag == true ? csSalesCodeStr += productList[i].csSalesCode : csSalesCodeStr += productList[i].csSalesModelCode;
					csThinqSalesCodeStr += productList[i].csSalesCode;	//LGEITF-1012
				}else{
					obuFlag == true ? csSalesCodeStr += productList[i].csSalesCode + ',' : csSalesCodeStr += productList[i].csSalesModelCode + ',';
					csThinqSalesCodeStr += productList[i].csSalesCode + ',';	//LGEITF-1012
				}
			}
		}		

		var serialNo = '';
		if(!isEmpty(serialList)){
			for(var i = 0; i < serialList.length; i++){
				if(i == serialList.length-1){
					serialNo += serialList[i];
				}else{
					serialNo += serialList[i] + ',';
				}
			}
		}
		//LGEITF-1012 start
		if (thinqRegisterPopup.addThinQinfo=='Y') {
			var form = $('<form action="'+redirectUrl+'" method="post">'+
				'<input type="hidden" name="csSalesCode" value="'+csThinqSalesCodeStr+'"/>'+
				'<input type="hidden" name="viewSalesCode" value="'+csThinqSalesCodeStr+'"/>'+
				'<input type="hidden" name="ocrSerialNo" value="'+serialNo+'"/>'+
				'<input type="hidden" name="scannedQR" value="'+postScannedQR+'"/>'+
				// LGEGMC-4167 Start
				'<input type="hidden" name="addThinQinfo" value="'+thinqRegisterPopup.addThinQinfo+'"/>'+
				'<input type="hidden" name="thinqPurchaseDate" value="'+thinqRegisterPopup.thinqPurchaseDate+'"/>'+
				'<input type="hidden" name="thinqPurchasePlace" value="'+thinqRegisterPopup.thinqPurchasePlace+'"/>'+
				'<input type="hidden" name="thinqDeviceId" value="'+thinqRegisterPopup.thinqDeviceId+'"/>'+
				'<input type="hidden" name="thinqRegDate" value="'+thinqRegisterPopup.thinqRegDate+'"/>'+
				// LGEGMC-4167 End
				'</form>'
				);
		} else {
		//LGEITF-1012 end
			var form = $('<form action="'+redirectUrl+'" method="post">'+
				'<input type="hidden" name="csSalesCode" value="'+csSalesCodeStr+'"/>'+
				'<input type="hidden" name="viewSalesCode" value="'+csSalesCodeStr+'"/>'+
				'<input type="hidden" name="ocrSerialNo" value="'+serialNo+'"/>'+
				'<input type="hidden" name="scannedQR" value="'+postScannedQR+'"/>'+
				// LGEGMC-4167 Start
				'<input type="hidden" name="addThinQinfo" value="'+thinqRegisterPopup.addThinQinfo+'"/>'+
				'<input type="hidden" name="thinqPurchaseDate" value="'+thinqRegisterPopup.thinqPurchaseDate+'"/>'+
				'<input type="hidden" name="thinqPurchasePlace" value="'+thinqRegisterPopup.thinqPurchasePlace+'"/>'+
				'<input type="hidden" name="thinqDeviceId" value="'+thinqRegisterPopup.thinqDeviceId+'"/>'+
				'<input type="hidden" name="thinqRegDate" value="'+thinqRegisterPopup.thinqRegDate+'"/>'+
				// LGEGMC-4167 End
				'</form>'
				);
		}
		
		$('body').append(form);
		$('.registerFileElem').val(''); // LGEGMC-4632
		$(form).submit();
	};
	// LGEGMC-3937 End

	var ocr = {
			localeCode: document.getElementsByTagName("html")[0].getAttribute("data-countrycode"),
			ocrImage : function(obj){
				var _ocr = this;
				this.file = obj.files[0];
				
				_ocr.getVisionApiImageAnnotage(obj.files[0]);
				
			}
			,getVisionApiImageAnnotage : function(content){
				var _ocr = this;
				var url = '/'+ocr.localeCode+'/mylg/api/registerProductOcr';
				
				var file = _ocr.file;
				var fileName = file.name;
				var fileInfoArr = fileName.split('.');
				var fileExt = '';
				
				fileExt = fileInfoArr[fileInfoArr.length -1];
				
				/*if( allowedFileExt.indexOf( fileExt.toLowerCase() ) === -1 ){
					var validationMsg = $('#validationMsg').val();
					alert(validationMsg);
					$('#fileElem').val('');
					return false;
				}*/
				
				var formData = new FormData(); // HTML5
				formData.append("file", _ocr.file);

				$('body').trigger('ajaxLoadBefore');
				ajax.noCacheCall(url, formData, 'json', function(data){
					//var redirectUrl = '/'+ocr.localeCode+'/my-lg/product-registration';
					if(data.status == 'success'){
						var productList = data.data[0].productList;
						var serialList = data.data[0].serialNo;
						/*LGEGMC-2653 s*/
						var serialNoTrackVal ='F';
						var productListTrackVal ='F';
						if(productList == null) productListTrackVal ='F';
						if(serialList == null) serialNoTrackVal = 'F';

						if(serialList != null && serialList.length == 1) serialNoTrackVal ='S';
						else if(serialList != null && serialList.length >= 2) serialNoTrackVal ='M';

						if(productList != null && productList.length == 1) productListTrackVal ='S';
						else if(productList != null && productList.length >= 2) productListTrackVal ='M';

						var rslt_case_val = serialNoTrackVal+'_'+productListTrackVal;
						console.log(rslt_case_val);
						//LGCOMMON-1554 Start
						var ocrSrc = device == "pc" ? "upload" : "camera";
						window.dataLayer.push({
							event: 'ocr_recognition_complete',
							ocr_rslt_case: rslt_case_val,
							ocr_src : ocrSrc
						});

						// LGEGMC-3361 Start
						if (typeof _trackEvent == 'function' && typeof _dl !== 'undefined') {
							_trackEvent(
									$.extend(_dl,{
										ocr_rslt_case:rslt_case_val,
										ocr_src : ocrSrc,
										page_event : {
											ocr_recognition_complete : true, 
										}
									})
								);
						}
						// LGEGMC-3361 End
						/*LGEGMC-2653 e*/
						//LGCOMMON-1554 End
						
						SubmitRegisterScan(productList, serialList); // LGEGMC-3937
					}else{
						location.assign(redirectUrl + '?ocrRetryFlag=Y');
					}
				});
				
			}
	};
	
	//LGESG-547,LGEGMC-4632 Start
	$(document).on('click touchend', '.registerFileSelect', function(e) {
		if($('.registerFileElem').length){
			e.preventDefault();
			$(".registerFileSelect:visible").next().click();
		}
	});
	//LGESG-547,LGEGMC-4632 End
	
	// LGEGMC-4632
	$('.registerFileElem').change(function(){
		ocr.ocrImage(this);
	});

	// LGEGMC-3937 Start
	const $qrCam = $('#qrCam'); // scan camera
	const qrCamView = document.createElement("video");
	const qrCanvaselement = document.getElementById("canvas");
	const qrCanvas = scanQRcodeFlag ? qrCanvaselement.getContext("2d") : null; //LGESG-547
	const qrLoadingmessage = document.getElementById("loadingMessage");
	const qrTickData = document.getElementById("tickData");
	let readyCamera = false;
	let closeCamera = false;
	let qrParams = null;
	console.log('Start - register product ocr'); // for mobile debug

	const scanQRcamera = {
		init : function(){
			const _camera = this;
			
			$qrCam.show();
			if(!readyCamera) _camera.setScanCamera();
			else _camera.openScanCamera('init'); // LGEGMC-4170
			
			_camera.addEvent();
		},
		setScanCamera : function(){
			const _camera = this;

			navigator.mediaDevices.getUserMedia({ audio: false, video: { facingMode: "environment" } }).then(function(stream) {
				qrCamView.srcObject = stream;
				qrCamView.setAttribute("playsinline", true);
				qrCamView.play();
				requestAnimationFrame(_camera.openScanCamera);
			});
			readyCamera = true;
		},
		openScanCamera : function(status){
			qrLoadingmessage.innerText = $qrCam.data('camReadyMsg');
			if(status === 'init') closeCamera = false; // LGEGMC-4170

			if(qrCamView.readyState === qrCamView.HAVE_ENOUGH_DATA){
				qrLoadingmessage.hidden = true;
				qrCanvaselement.hidden = false;

				qrCanvaselement.height = qrCamView.videoHeight;
				qrCanvaselement.width = qrCamView.videoWidth;
				qrCanvas.drawImage(qrCamView, 0, 0, qrCanvaselement.width, qrCanvaselement.height);
				const imageData = qrCanvas.getImageData(0, 0, qrCanvaselement.width, qrCanvaselement.height);
				const code = jsQR(imageData.data, imageData.width, imageData.height, {
					inversionAttempts: "dontInvert",
				});

				if(code){
					scanQRcamera.drawLine(code.location.topLeftCorner, code.location.topRightCorner, "#FF3B58");
					scanQRcamera.drawLine(code.location.topRightCorner, code.location.bottomRightCorner, "#FF3B58");
					scanQRcamera.drawLine(code.location.bottomRightCorner, code.location.bottomLeftCorner, "#FF3B58");
					scanQRcamera.drawLine(code.location.bottomLeftCorner, code.location.topLeftCorner, "#FF3B58");

					console.log('scan success : ', code.data);
					qrTickData.innerText = code.data
					closeCamera = true;

					scanQRcamera.postData(code.data);
				}
			}
			if(!closeCamera) requestAnimationFrame(scanQRcamera.openScanCamera);
		},
		postData : function(data){
			qrParams = data.substring(data.indexOf('?'), data.length);
			const url = '/'+ COUNTRY_CODE +'/my-lg/api/registerProductOcrScanQRcode';	//LGEITF-895
			const heModel = this.getCodeData().salesmodel;
			const heSerial = this.getCodeData().serialno;
			const haModel = this.getCodeData().m;
			const haSerial = this.getCodeData().s;
			let scanParam, productCode, serialNo;

			if(heModel !== undefined && heSerial !== undefined){
				productCode = heModel;
				serialNo = heSerial;
			}else if(haModel !== undefined && haSerial !== undefined){
				productCode = haModel;
				serialNo = haSerial;
			};
			scanParam = 'productCode='+productCode+'&serialNo='+serialNo;

			$('body').trigger('ajaxLoadBefore');
			ajax.noCacheCall(url, scanParam, 'json', function(data){
				if(data.status == 'success'){
					const productList = data.data[0].productList;
					const serialList = data.data[0].serialNo === 'undefined' ? null : [data.data[0].serialNo]; // LGEGMC-4170
					postScannedQR = 'Y';
					//LGCOMMON-1554 Start
					var serialNoTrackVal ='F';
					var productListTrackVal ='F';
					if(productList == null) productListTrackVal ='F';
					if(serialList == null) serialNoTrackVal = 'F';

					if(serialList != null && serialList.length == 1) serialNoTrackVal ='S';
					else if(serialList != null && serialList.length >= 2) serialNoTrackVal ='M';

					if(productList != null && productList.length == 1) productListTrackVal ='S';
					else if(productList != null && productList.length >= 2) productListTrackVal ='M';

					var rslt_case_val = serialNoTrackVal+'_'+productListTrackVal;
					window.dataLayer.push({
						event: 'ocr_recognition_complete',
						ocr_rslt_case: rslt_case_val,
						ocr_src:'qr'
					});

					if (typeof _trackEvent == 'function' && typeof _dl !== 'undefined') {
						_trackEvent(
								$.extend(_dl,{
									ocr_rslt_case:rslt_case_val,
									ocr_src:'qr',
									page_event : {
										ocr_recognition_complete : true, 
									}
								})
							);
					}
					//LGCOMMON-1554 End
					SubmitRegisterScan(productList, serialList);
				}else{
					location.assign(redirectUrl + '?ocrRetryFlag=Y');
				}
			});
		},
		getCodeData : function(){
			const params = {};
			qrParams.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str, key, value) { params[key] = value; });
			return params;
		},
		drawLine : function(begin, end, color){
			qrCanvas.beginPath();
			qrCanvas.moveTo(begin.x, begin.y);
			qrCanvas.lineTo(end.x, end.y);
			qrCanvas.lineWidth = 4;
			qrCanvas.strokeStyle = color;
			qrCanvas.stroke();
		},
		addEvent : function(){
			$(document).on('click', '#qrCam .close, #qrCam .find-qr', function(){
				closeCamera = true;
				$qrCam.hide();

				if($(this).hasClass('find-qr'))
					$('#modal_find_my_model_qrcode [href="#fmmd_qrcode_tab2"]').trigger('click');
			});
		},
	};

	if(scanQRcodeFlag){
		$(document).on("click", scanQR, function(){
			if($(scanQR).attr("href") === "#") // logged in
	 			scanQRcamera.init();
		});
	};
	// LGEGMC-3937 End

	// LGEGMC-4167 Start
	const thinqRegisterPopup = {
		flag: sessionStorage.getItem(THINQ_REGISTER_PRODUCT_FLAG),
		count: Number( sessionStorage.getItem(THINQ_PRODUCT_COUNT) ),
		addThinQinfo: 'N',
		thinqPurchaseDate: null,
		thinqPurchasePlace: null,
		thinqDeviceId: null,
		thinqRegDate: null,
		init: function(){
			const self = this;

			$(document).on('click touchend', '.product-item .bottom-container .btn-primary', function(e){
				e.preventDefault();
				thinqReg.ajaxLoad();
				if($(this).is('.add')) self.addInfo($(this)); // add info in manually page
				else self.directRegister(this); // direct register logic
			});
		},
		addInfo: function($btn){
			const self = thinqRegisterPopup;

			self.addThinQinfo = 'Y';
			self.thinqPurchaseDate = $btn.data('purchaseDate');
			self.thinqPurchasePlace = $btn.data('purchaseChannelName');
			self.thinqDeviceId = $btn.data('deviceId');
			self.thinqRegDate = $btn.data('thinqRegDate');

			const url = '/'+ COUNTRY_CODE +'/my-lg/api/registerProductOcrScanQRcode';	//LGEITF-895
			const productCode = $btn.data('productCode');
			const serialNo = $btn.data('serialNo');
			const param = 'productCode='+productCode+'&serialNo='+serialNo;

			ajax.noCacheCall(url, param, 'json', function (data) {
				if(data.status == 'success'){
					const productList = data.data[0].productList;
					const serialList = data.data[0].serialNo === 'undefined' ? null : [data.data[0].serialNo];

					SubmitRegisterScan(productList, serialList);
				}
			});
		},
		directRegister: function(btn){
			console.log('directRegister start');
			const self = thinqRegisterPopup;
			const url = '/'+ COUNTRY_CODE +'/my-lg/insertMyProduct.lgajax';
			const $btn = $(btn);

			let directResult = false;
			let formData = new FormData();
			formData.append('type', 'thinq');

			const btnDataList = btn.dataset;
			for(name in btnDataList) formData.append(name, btnDataList[name]);

			// async: false 로 인한 로딩바 미노출 이슈 개선을 위한 setTimeout
			setTimeout(function(){
				$.ajax({
					url: url,
					type: 'post',
					data: formData,
					async: false,
					dataType: 'json',
					contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
					withCredentials: true,
					enctype: 'multipart/form-data',
					processData: false,
					contentType: false,
					success: function(data) {
						console.log('for debug directRegister() data', data);
						if(data.result){
							// update count
							const updatedCount = Number( sessionStorage.getItem(THINQ_PRODUCT_COUNT) ) - 1;
							$('[data-menu-name="register-product"] '+ thinqReg.COUNT_CLASS[0] +', .modal-product-register-with-thinq '+ thinqReg.COUNT_CLASS[1]).text(updatedCount); // gnb info box, popup total count
							sessionStorage.setItem(THINQ_PRODUCT_COUNT, updatedCount); // session storage

							$btn.closest('.product-item').remove();
							directResult = true;

							// 마지막 제품 바로 등록 후
							// 1. 팝업 내 no-list info : show
							// 2. gnb info box : hide
							if(!updatedCount){
								thinqReg.thinqPopup.find('.no-list').removeClass('d-none');
								thinqReg.gnbRegisterThinqBox.hide();
								thinqReg.removeDot();
							}
						}
						else{
							const b2bNoCompany = 'Please register your phone number or address information in my profile.';
							if(data.error.message === b2bNoCompany){
								sessionStorage.setItem(THINQ_B2B_NO_COMPANY, 'Y');
								// go to no campany page
								window.location.href = '/' + COUNTRY_CODE + '/mylg/product-no-campany'; 
							}
							else console.log('[insertMyProduct] '+data.error.message);
						}
					},
					complete: function() {
						$('body').trigger('ajaxLoadEnd');
						if(directResult) $('#registerComplete').toast('show');
					}
				});
			}, 0);

		}
	}

	if(thinqRegisterPopup.flag === 'Y' && thinqRegisterPopup.count > 0)
		thinqRegisterPopup.init();
	// LGEGMC-4167 End

	var isEmpty = function(value){ 
		if( value == "" || value == null || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length ) ){ 
			return true; 
		}else{
			return false; 
		} 
	};

		
});